import { graphql } from "@/lib/gql/__generated__";

export const RoomList_DesignPage_Query = graphql(`
	query RoomList_DesignPage($hotelID: ID!) {
		roomList(hotelID: $hotelID) {
			id
			rooms {
				id
				inSale
				isDormitoryType
				name
				mainKeyVisual {
					bucket
					key
					region
					mimeType
					fileName
				}
				roomID
			}
			dummy {
				id
				inSale
				roomID
				mainKeyVisual {
					bucket
					key
					region
					mimeType
					fileName
				}
				name
			}
		}
	}
`);
